import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import AppUtil from "utilities/AppUtil";
import httpRequest from "../../services/httpRequest";
// Main URL Endpoint
const _urlPrefix = "/client-user";


export const fetchListUserCoordinator = createAsyncThunk(
  "clientUser/fetchListUserCoordinator",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/coordinator`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchUserCoordinatorDetail = createAsyncThunk(
  "clientUser/fetchUserCoordinatorDetail",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/coordinator/detail/${id}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchListUserHospital = createAsyncThunk(
  "clientUser/fetchListUserHospital",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/hospital`,
      method: "GET",
      params: AppUtil.toSnakeCaseKey(params)
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const fetchUserHospitalDetail = createAsyncThunk(
  "clientUser/fetchUserHospitalDetail",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/hospital/detail/${id}`,
      method: "GET"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceCreateUserCoordinator = createAsyncThunk(
  "clientUser/reduceCreateUserCoordinator",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/coordinator`,
      method: "POST",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.create.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceCreateUserHospital = createAsyncThunk(
  "clientUser/reduceCreateUserHospital",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/hospital`,
      method: "POST",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.create.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceUpdateUserCoordinator = createAsyncThunk(
  "clientUser/reduceUpdateUserCoordinator",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/coordinator/update/${id}`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceUpdateUserHospital = createAsyncThunk(
  "clientUser/reduceUpdateUserHospital",
  async (params) => {
    const { id } = params;
    const result = await httpRequest({
      url: `${_urlPrefix}/hospital/update/${id}`,
      method: "PUT",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.update.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceDeleteUserCoordinator = createAsyncThunk(
  "clientUser/reduceDeleteUserCoordinator",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/coordinator/delete`,
      method: "DELETE",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.remove.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);
export const reduceDeleteUserHospital = createAsyncThunk(
  "clientUser/reduceDeleteUserHospital",
  async (params) => {
    const result = await httpRequest({
      url: `${_urlPrefix}/hospital/delete`,
      method: "DELETE",
      data: AppUtil.toSnakeCaseKey(params),
      successMessage: "toast.remove.200"
    });
    if (!result) {
      return;
    }
    return result.data;
  }
);

const initialState = {
  listUserCoordinator: [],
  listUserHospital: [],
  userCoordinator: {},
  userHospital: {}
};

const clientUser = createSlice({
  name: "clientUser",
  initialState: initialState,
  reducers: {
  },
  extraReducers: {
    [fetchUserCoordinatorDetail.fulfilled]: (state, action) => {
      if (action.payload) {
        state.userCoordinator = action.payload;
        for (const key in state.detail) {
          if (!state.userCoordinator[key]) {
            state.userCoordinator[key] = '';
          }
        }
      }
    },
    [fetchUserHospitalDetail.fulfilled]: (state, action) => {
      if (action.payload) {
        state.userHospital = action.payload;
        for (const key in state.detail) {
          if (!state.userHospital[key]) {
            state.userHospital[key] = '';
          }
        }
      }
    },
    [fetchListUserCoordinator.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.listUserCoordinator = payload.content;
      }
    },
    [fetchListUserHospital.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.listUserHospital = payload.content;
      }
    }
  }
});

const { reducer } = clientUser;
export default reducer;

export const getUserCoordinatorDetail = createSelector(
  (state) => state.clientUser.userCoordinator,
  (user) => user
);
export const getUserHospitalDetail = createSelector(
  (state) => state.clientUser.userHospital,
  (user) => user
);
export const getUserCoordinatorList = createSelector(
  state => state.clientUser.listUserCoordinator,
  list => list
);
export const getUserHospitalList = createSelector(
  state => state.clientUser.listUserHospital,
  list => list
);
